<template>
	<main-tabs :links="links">
		<keep-alive>
			<router-view></router-view>
		</keep-alive>
	</main-tabs>
</template>

<script>
	export default {
		data() {
			return {
				links: [{
					to: {
						path: '/budget-plan/plan'
					},
					label: '调整计划'
				}, {
					to: {
						path: '/budget-plan/config'
					},
					label: '规则配置'
				}]
			}
		}
	}
</script>
